/* ==========================================================================
   Ajiaco y Frijoles — Núcleo del pedido
   Store en memoria + sessionStorage, render de resumen, barra fija y checkout.
   Sin dependencias.
   ========================================================================== */
(function () {
  'use strict';

  var CONFIG = readConfig();
  var STORAGE_KEY = 'ayf:order:v3';

  /* ------------------------------------------------------------ Utilidades */

  function readConfig() {
    var node = document.getElementById('ayf-config');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
  }

  function formatMoney(cents) {
    var format = CONFIG.moneyFormat || '${{amount}}';
    var value = Number(cents) || 0;

    function group(number, decimals, thousands, decimalSep) {
      var fixed = (number / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return decimals && parts[1] ? intPart + decimalSep + parts[1] : intPart;
    }

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount':
          return group(value, 2, ',', '.');
        case 'amount_no_decimals':
          return group(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return group(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return group(value, 0, '.', ',');
        case 'amount_with_space_separator':
          return group(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return group(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator':
          return group(value, 2, "'", '.');
        default:
          return group(value, 2, ',', '.');
      }
    });
  }

  function announce(message) {
    var region = document.querySelector('[data-ayf-announcer]');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 60);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  /* ---------------------------------------------------------------- Store */

  var listeners = [];

  var state = {
    items: {},
    drinks: {},
    additions: {},
    customer: { address: '', barrio: '', phone: '', notes: '', branch: '', branchName: '', branchAddress: '' },
    zone: null,
    schedule: null
  };

  function load() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (saved && typeof saved === 'object') {
        state.items = saved.items || {};
        state.drinks = saved.drinks || {};
        state.additions = saved.additions || {};
        state.customer = Object.assign(state.customer, saved.customer || {});
        state.zone = saved.zone || null;
      }
    } catch (e) {
      /* almacenamiento no disponible: el pedido vive solo en memoria */
    }
  }

  function persist() {
    try {
      window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ items: state.items, drinks: state.drinks, additions: state.additions, customer: state.customer, zone: state.zone })
      );
    } catch (e) {
      /* silencioso */
    }
  }

  function emit() {
    persist();
    var snapshot = getState();
    listeners.forEach(function (fn) {
      fn(snapshot);
    });
  }

  function getState() {
    return {
      items: state.items,
      drinks: state.drinks,
      additions: state.additions,
      customer: state.customer,
      zone: state.zone,
      schedule: state.schedule,
      lines: getLines(),
      totals: getTotals()
    };
  }

  function getLines() {
    var lines = [];
    Object.keys(state.items).forEach(function (id) {
      lines.push(Object.assign({ group: 'plato', id: id }, state.items[id]));
    });
    Object.keys(state.drinks).forEach(function (id) {
      lines.push(Object.assign({ group: 'bebida', id: id }, state.drinks[id]));
    });
    Object.keys(state.additions).forEach(function (id) { lines.push(Object.assign({ group: 'adicion', id: id }, state.additions[id])); });
    return lines;
  }

  function getTotals() {
    var subtotal = getLines().reduce(function (sum, line) {
      return sum + line.price * line.quantity;
    }, 0);
    var delivery = state.zone && state.zone.fee ? state.zone.fee : 0;
    var count = getLines().reduce(function (sum, line) {
      return sum + line.quantity;
    }, 0);
    return {
      count: count,
      subtotal: subtotal,
      delivery: delivery,
      total: subtotal + delivery,
      hasPlate: Object.keys(state.items).length > 0
    };
  }

  function addLine(bucket, payload) {
    var id = String(payload.variantId);
    var current = bucket[id];
    var quantity = payload.quantity == null ? 1 : payload.quantity;
    if (current) {
      current.quantity += quantity;
    } else {
      bucket[id] = {
        variantId: id,
        title: payload.title,
        variantTitle: payload.variantTitle || '',
        price: Number(payload.price) || 0,
        quantity: quantity
      };
    }
    if (bucket[id].quantity < 1) delete bucket[id];
  }

  var Order = {
    subscribe: function (fn) {
      listeners.push(fn);
      fn(getState());
      return function () {
        listeners = listeners.filter(function (item) {
          return item !== fn;
        });
      };
    },

    getState: getState,
    formatMoney: formatMoney,
    announce: announce,

    addProduct: function (group, payload) {
      var bucket = group === 'bebida' ? state.drinks : group === 'adicion' ? state.additions : state.items;
      addLine(bucket, payload);
      emit();
      announce(payload.title + ' agregado al pedido.');
    },

    addPlate: function (payload) {
      addLine(state.items, payload);
      emit();
      announce(payload.title + ' agregado al pedido.');
    },

    setDrink: function (payload) {
      var id = String(payload.variantId);
      if (!payload.quantity) {
        delete state.drinks[id];
      } else {
        state.drinks[id] = {
          variantId: id,
          title: payload.title,
          variantTitle: payload.variantTitle || '',
          price: Number(payload.price) || 0,
          quantity: payload.quantity
        };
      }
      emit();
    },

    updateQuantity: function (group, variantId, quantity) {
      var bucket = group === 'bebida' ? state.drinks : group === 'adicion' ? state.additions : state.items;
      var id = String(variantId);
      if (!bucket[id]) return;
      if (quantity < 1) {
        delete bucket[id];
      } else {
        bucket[id].quantity = quantity;
      }
      emit();
    },

    removeLine: function (group, variantId) {
      var bucket = group === 'bebida' ? state.drinks : group === 'adicion' ? state.additions : state.items;
      delete bucket[String(variantId)];
      emit();
    },

    setZone: function (zone) {
      state.zone = zone;
      emit();
    },

    setCustomer: function (patch) {
      state.customer = Object.assign(state.customer, patch);
      emit();
    },

    setSchedule: function (schedule) {
      state.schedule = schedule;
      emit();
    },

    reset: function () {
      state.items = {};
      state.drinks = {};
      state.additions = {};
      state.zone = null;
      emit();
    },

    checkout: checkout
  };

  window.AYF = Order;

  /* ------------------------------------------------------------- Checkout */

  var checkoutInFlight = false;

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(
          function (data) {
            throw new Error(data.description || data.message || 'Error de carrito');
          },
          function () {
            throw new Error('Error de carrito');
          }
        );
      }
      return response.json();
    });
  }

  function checkout(trigger) {
    if (window.AYFCoverageSync) window.AYFCoverageSync();
    var totals = getTotals();

    if (!totals.hasPlate) {
      announce('Agrega un plato para continuar.');
      scrollToSection(CONFIG.menuAnchor || '#menu');
      return Promise.resolve(false);
    }

    if (CONFIG.requireCoverage !== false && !state.zone) {
      announce('Selecciona tu sede y barrio para continuar.');
      showCheckoutError('Selecciona tu sede y un barrio de cobertura para continuar.');
      scrollToSection(CONFIG.coverageAnchor || '#cobertura');
      var addressField = document.querySelector('[data-ayf-address]');
      if (addressField) addressField.focus();
      return Promise.resolve(false);
    }

    if (!state.customer.branch || !state.zone || !state.customer.address.trim()) {
      showCheckoutError('Escribe la dirección completa para continuar.');
      scrollToSection(CONFIG.coverageAnchor || '#cobertura');
      var address = document.querySelector('[data-ayf-address]');
      if (address) address.focus();
      return Promise.resolve(false);
    }

    var phoneDigits = String(state.customer.phone || '').replace(/\D/g, '');
    if (phoneDigits.length < 10 || phoneDigits.length > 15) {
      showCheckoutError('Escribe un número de celular válido para coordinar la entrega.');
      scrollToSection(CONFIG.coverageAnchor || '#cobertura');
      var phone = document.querySelector('[data-ayf-phone]');
      if (phone) phone.focus();
      return Promise.resolve(false);
    }

    if (state.zone && state.zone.fee > 0 && !state.zone.variantId) {
      showCheckoutError('El costo de domicilio aún no está configurado. Contáctanos para confirmar el pedido.');
      return Promise.resolve(false);
    }

    if (checkoutInFlight) return Promise.resolve(false);
    checkoutInFlight = true;
    if (trigger) {
      trigger.setAttribute('aria-disabled', 'true');
      trigger.dataset.label = trigger.textContent;
      trigger.textContent = 'Preparando tu pedido…';
    }

    var items = getLines().map(function (line) {
      return { id: Number(line.variantId), quantity: line.quantity };
    });

    if (state.zone && state.zone.variantId) {
      items.push({ id: Number(state.zone.variantId), quantity: 1 });
    }

    var attributes = {
      'Sede': state.customer.branchName || '',
      'Dirección de sede': state.customer.branchAddress || '',
      'Dirección': state.customer.address || '',
      'Barrio': state.customer.barrio || '',
      'Teléfono': state.customer.phone || '',
      'Zona de entrega': state.zone ? state.zone.name : '',
      'Costo del domicilio': state.zone && state.zone.fee != null ? formatMoney(state.zone.fee) : 'Según la dirección en el checkout',
      'Indicaciones': state.customer.notes || ''
    };

    if (state.schedule && state.schedule.open === false) {
      attributes['Entrega programada'] = 'Se prepara a partir de ' + (state.schedule.nextOpening || 'la apertura');
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return postJSON(root + 'cart/clear.js', {})
      .then(function () {
        return postJSON(root + 'cart/add.js', { items: items });
      })
      .then(function () {
        return postJSON(root + 'cart/update.js', { attributes: attributes, note: state.customer.notes || '' });
      })
      .then(function () {
        window.location.href = root + 'checkout';
        return true;
      })
      .catch(function (error) {
        checkoutInFlight = false;
        if (trigger && trigger.dataset.label) {
          trigger.removeAttribute('aria-disabled');
          trigger.textContent = trigger.dataset.label;
        }
        showCheckoutError(error.message);
        return false;
      });
  }

  function showCheckoutError(message) {
    var box = document.querySelector('[data-ayf-checkout-error]');
    var text = 'No pudimos preparar el pedido. Revisa la disponibilidad de los productos e inténtalo de nuevo.';
    if (message && message.length < 160) text = message;
    if (box) {
      box.textContent = text;
      box.hidden = false;
    }
    announce(text);
  }

  function scrollToSection(selector) {
    var target = document.querySelector(selector);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* -------------------------------------------------------- Menú y bebidas */

  function bindMenu() {
    document.querySelectorAll('[data-ayf-add]').forEach(function (button) {
      if (button.dataset.ayfBound === 'true') return;
      button.dataset.ayfBound = 'true';
      button.addEventListener('click', function () {
        var card = button.closest('[data-ayf-plate]');
        if (!card) return;
        var selected = card.querySelector('input[type="radio"]:checked');
        if (!selected) return;

        Order.addProduct(card.dataset.ayfGroup || 'plato', {
          variantId: selected.value,
          title: card.dataset.ayfPlate,
          variantTitle: selected.dataset.name,
          price: Number(selected.dataset.price),
          quantity: 1
        });

        button.classList.add('is-added');
        var original = button.dataset.labelDefault || button.textContent;
        button.dataset.labelDefault = original;
        button.textContent = 'Agregado ✓';
        window.setTimeout(function () {
          button.classList.remove('is-added');
          button.textContent = original;
        }, 1400);
      });
    });
  }

  function bindDrinks() {
    document.querySelectorAll('[data-ayf-drink]').forEach(function (drink) {
      if (drink.dataset.ayfBound === 'true') return;
      drink.dataset.ayfBound = 'true';
      var checkbox = drink.querySelector('input[type="checkbox"]');
      var stepper = drink.querySelector('[data-ayf-drink-qty]');
      var output = drink.querySelector('output');

      function sync() {
        var quantity = checkbox.checked ? Number(output.value) || 1 : 0;
        if (stepper) stepper.hidden = !checkbox.checked;
        Order.setDrink({
          variantId: checkbox.value,
          title: drink.dataset.ayfDrink,
          price: Number(checkbox.dataset.price),
          quantity: quantity
        });
      }

      checkbox.addEventListener('change', function () {
        if (checkbox.checked && output) output.value = Math.max(1, Number(output.value) || 1);
        sync();
      });

      if (stepper) {
        stepper.querySelectorAll('button').forEach(function (button) {
          button.addEventListener('click', function () {
            var next = Math.min(10, Math.max(1, (Number(output.value) || 1) + Number(button.dataset.step)));
            output.value = next;
            sync();
          });
        });
      }
    });
  }

  /* -------------------------------------------------------------- Resumen */

  function renderSummary(snapshot) {
    var container = document.querySelector('[data-ayf-summary]');
    if (!container) return;

    var list = container.querySelector('[data-ayf-lines]');
    var empty = container.querySelector('[data-ayf-empty]');
    var lines = snapshot.lines;

    if (list) {
      if (!lines.length) {
        list.innerHTML = '';
      } else {
        list.innerHTML = lines
          .map(function (line) {
            return [
              '<li class="ayf-line" data-group="' + line.group + '" data-variant="' + escapeHtml(line.variantId) + '">',
              '<div class="ayf-line__info">',
              '<span class="ayf-line__name">' + escapeHtml(line.title) + '</span>',
              '<span class="ayf-line__meta">' +
                escapeHtml(line.variantTitle || '') +
                (line.variantTitle ? ' · ' : '') +
                formatMoney(line.price) +
                ' c/u</span>',
              '</div>',
              '<div class="ayf-line__right">',
              '<div class="ayf-stepper">',
              '<button type="button" data-ayf-line-step="-1" aria-label="Quitar una unidad de ' +
                escapeHtml(line.title) +
                '">−</button>',
              '<output>' + line.quantity + '</output>',
              '<button type="button" data-ayf-line-step="1" aria-label="Agregar una unidad de ' +
                escapeHtml(line.title) +
                '">+</button>',
              '</div>',
              '<span class="ayf-line__price">' + formatMoney(line.price * line.quantity) + '</span>',
              '</div>',
              '</li>'
            ].join('');
          })
          .join('');
      }
    }

    if (empty) empty.hidden = lines.length > 0;

    var deliveryRow = container.querySelector('[data-ayf-delivery-row]');
    var deliveryValue = container.querySelector('[data-ayf-delivery]');
    if (deliveryValue) {
      deliveryValue.textContent = snapshot.zone && snapshot.zone.fee != null ? formatMoney(snapshot.totals.delivery) : 'Se calcula al pagar';
    }
    if (deliveryRow) {
      var zoneLabel = deliveryRow.querySelector('[data-ayf-zone-name]');
      if (zoneLabel) zoneLabel.textContent = snapshot.zone ? ' · ' + snapshot.zone.name : '';
    }

    setText(container, '[data-ayf-subtotal]', formatMoney(snapshot.totals.subtotal));
    setText(container, '[data-ayf-total]', formatMoney(snapshot.totals.total));

    var checkoutButton = container.querySelector('[data-ayf-checkout]');
    if (checkoutButton) checkoutButton.disabled = !snapshot.totals.hasPlate;
  }

  function setText(scope, selector, value) {
    var node = scope.querySelector(selector);
    if (node) node.textContent = value;
  }

  function bindSummary() {
    var container = document.querySelector('[data-ayf-summary]');
    if (!container || container.dataset.ayfBound === 'true') return;
    container.dataset.ayfBound = 'true';

    container.addEventListener('click', function (event) {
      var step = event.target.closest('[data-ayf-line-step]');
      if (step) {
        var line = step.closest('.ayf-line');
        var quantity = Number(line.querySelector('output').textContent) + Number(step.dataset.ayfLineStep);
        Order.updateQuantity(line.dataset.group, line.dataset.variant, quantity);
        return;
      }

      var checkoutButton = event.target.closest('[data-ayf-checkout]');
      if (checkoutButton) {
        event.preventDefault();
        Order.checkout(checkoutButton);
      }
    });
  }

  /* ---------------------------------------------------------- Barra fija */

  function bindBar() {
    var bar = document.querySelector('[data-ayf-bar]');
    if (!bar || bar.dataset.ayfBound === 'true') return;
    bar.dataset.ayfBound = 'true';

    bar.querySelector('[data-ayf-bar-action]').addEventListener('click', function (event) {
      event.preventDefault();
      var snapshot = getState();
      if (!snapshot.zone && CONFIG.requireCoverage !== false) {
        scrollToSection(CONFIG.coverageAnchor || '#cobertura');
        return;
      }
      scrollToSection(CONFIG.summaryAnchor || '#resumen');
    });

    Order.subscribe(function (snapshot) {
      var totals = snapshot.totals;
      bar.classList.toggle('is-visible', totals.count > 0);
      setText(bar, '[data-ayf-bar-total]', formatMoney(totals.total));
      setText(
        bar,
        '[data-ayf-bar-count]',
        totals.count === 1 ? '1 artículo en tu pedido' : totals.count + ' artículos en tu pedido'
      );
    });
  }

  /* -------------------------------------------------------------- Reveal */

  function bindReveal() {
    var targets = document.querySelectorAll('.ayf-reveal');
    if (!targets.length || !('IntersectionObserver' in window)) {
      targets.forEach(function (node) {
        node.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    targets.forEach(function (node) {
      observer.observe(node);
    });
  }

  /* ----------------------------------------------------------------- Init */

  function init() {
    load();
    bindMenu();
    bindDrinks();
    bindSummary();
    bindBar();
    bindReveal();
    Order.subscribe(renderSummary);

    document.querySelectorAll('[data-ayf-checkout-shortcut]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        Order.checkout(button);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    bindMenu();
    bindDrinks();
    bindSummary();
    bindBar();
    bindReveal();
    emit();
  });
})();
